// extracted by mini-css-extract-plugin
export default {"styledRichText":"bQetMNoSISA2dia1sgPu"};